<template>
	<t-dialog
		:isShown="!!modalUrl"
		:hasFooter="false"
		@close="close"
	>
		<img :src="modalUrl" class="picture">
	</t-dialog>
</template>

<script>
import { mapState, mapActions } from './store/unknownItems.store.js';

export default {
	name: 'PictureModal',
	computed: { ...mapState(['modalUrl']) },
	methods: {
		...mapActions(['setModalUrl']),
		close() {
			this.setModalUrl(undefined);
		},
	},
};
</script>

<style lang="scss" scoped>
.picture {
	max-height: 700px;
	max-width: 700px;
}
</style>

